// mds-dojo — dijit/form/ToggleButton — FAITHFUL port of references/dijit/form/ToggleButton.js.
//
// *** ADDED OUTSIDE THE NAMED PORT SCOPE (dijit/Editor.ts + dijit/_editor/**) ***
// Required by dijit/Editor's togglePluginFactory (bold/italic/underline/strikethrough/
// subscript/superscript). Not previously in mds. Ported additively (NO stubs).
//
// ADAPTATIONS: `dojo/_base/declare` → `../../dojo/_base/declare-runtime`;
//   `kernel.deprecated` shimmed to a no-op when the slim mds kernel lacks it.
import declare from '../../dojo/_base/declare-runtime'; // declare
import kernel from '../../dojo/_base/kernel'; // kernel.deprecated
import Button from './Button';
import _ToggleButtonMixin from './_ToggleButtonMixin';

var deprecated: any = (kernel as any).deprecated || function () { /* no-op shim */ };

// module:
//		dijit/form/ToggleButton

export default declare("dijit.form.ToggleButton", [Button, _ToggleButtonMixin], {
	// summary:
	//		A templated button widget that can be in two states (checked or not).
	//		Can be base class for things like tabs or checkbox or radio buttons.

	baseClass: "dijitToggleButton",

	setChecked: function(/*Boolean*/ checked: any){
		// summary:
		//		Deprecated.  Use set('checked', true/false) instead.
		deprecated("setChecked("+checked+") is deprecated. Use set('checked',"+checked+") instead.", "", "2.0");
		this.set('checked', checked);
	}
});
